<template>
  <div class="game-points-panel game-points-panel-border" :style="gamePointsPanleStyle()">
    <div class="game-points-label">Punkty</div>
    <div class="game-points-text">
      <span class="game-current-points"> {{ currentPoints }} </span> /
      <span class="game-max-points"> {{ maxPoint }} </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'tr-game-points-panel',

  props: {
    pos: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  methods: {
    gamePointsPanleStyle() {
      return { left: `${this.position.x}%`, top: `${this.position.y}%`, width: `${this.panelWidth}%` };
    },
  },
  computed: {
    multiStageTest() {
      return this.$store.getters.multiStageTest;
    },
    maxPoint() {
      return this.$store.getters.stagesMaxPoints;
    },
    currentPoints() {
      return this.$store.getters.stagesCurrentPointStatus;
    },
    panelWidth() {
      return 8;
    },
    position() {
      if (_.isEmpty(this.pos)) {
        return { x: 0, y: 92.8 };
      }
      return this.pos;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/iconColor';

.disable-shadow {
  opacity: 0.5;
  cursor: not-allowed;
}
.game-points-panel {
  position: absolute;
  width: 15%;
  height: 7%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .game-points-label {
    font-size: 1.4rem;
    line-height: 1.7rem;
  }
  .game-points-text {
    font-size: 3rem;
    line-height: 2.5rem;
    font-weight: bold;
    .game-current-points {
      color: #212529;
    }
    .game-max-points {
      color: #212529;
    }
  }
}
.demo-tr-game-points-panel {
  width: 10%;
}
.game-points-panel-border {
  // border: solid 1px black;
  border-radius: 10px;
  background-color: $backgroundControlPanelColor;
}
</style>
